import { useState, useRef, useEffect } from 'react';
import type { LifecycleAdapter } from '../../adapters/types';

export function useContainerSize(lifecycle: LifecycleAdapter) {
  const ref = useRef<HTMLDivElement>(null);
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const unsub = lifecycle.onResize(el, (rect) => {
      setSize({ width: rect.width, height: rect.height });
    });
    const r = el.getBoundingClientRect();
    setSize({ width: r.width, height: r.height });
    return unsub;
  }, [lifecycle]);

  return { ref, size };
}
